/*
 * Module for working with Recommendations
 */

define([
  "marionette",
  "messaging/messenger",
  "./recommendationsView",
  "./recommendationsModel",
], function (Marionette, Messenger, RecommendationsView, RecommendationsModel) {
  var RecommendationsModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "Recommendations";
      this.region = options.region;
      this._setUpVents();
    },
    save: function () {
      var model = new RecommendationsModel.UpdateTopicSearch();
      Messenger.vent.trigger("show:saving:display");
      model.save(null, {
        success: function () {
          Messenger.vent.trigger("close:saving:display");
          Messenger.okDialog("admin.recommendations.refreshStarted");
        },
        error: function (model, response) {
          Messenger.vent.trigger("close:saving:display");
          Messenger.showErrorFromResponse(response);
        },
      });
    },
    show: function () {
      var _this = this;
      this.view = new RecommendationsView.recommendationsView();
      Messenger.onSave(() => Messenger.saveAttempted(true));

      this.view.on(
        "recommendations:refresh:click",
        function () {
          _this.save(false);
        },
        this,
      );

      this.showRegion(this.view, { loading: true });
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:recommendations",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:recommendations",
        function () {
          this.show();
        },
        this,
      );
    },
  });

  return RecommendationsModule;
});
